module.exports = new __parcel__URL__("build_text.9cdf2127.png").toString();